import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";

import video from "../assets/videos/dtc1.mp4";
import imageurl1 from "../assets/images/dtcremoval1.png";
import video2 from "../assets/videos/service2.mp4";
function DTCRemoval() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Ook wel bekend als foutcode uitschakelen / uitschrijven. Geeft uw
        voertuig een foutcode aan die blijft terugkomen nadat deze is gewist?
        Soms kan het helpen om een onderdeel te vervangen aan uw voertuig, maar
        in sommige gevallen blijft de foutcode alsnog terugkomen. Het kan hier
        gaan om verschillende soorten foutcodes in het motormanagement. Bij
        X-TREMETUNINGS kunnen wij door de oorzaak van de foutcode op te sporen
        de foutcode volledig softwarematig uitschakelen. De diagnostische
        functionaliteit van het voertuig blijft voor de rest correct werken.
      </p>
      <br />
      <h3 className="text-xl font-bold">
        Foutcode (DTC) opsporen en uitschakelen
      </h3>
      <p className="text-white text-lg">
        Foutcode, oftewel Diagnostic Trouble Codes (DTC), zijn opgeslagen door
        het motormanagement van een voertuig, omdat er ergens een storing in het
        systeem optreedt. De foutcodes geven vaak aan waar een bepaald
        probleemgebied zich bevindt, om zodoende te helpen zoeken naar waar de
        fout zich kan voordoen.
      </p>
      <br />
      <h3 className="text-xl font-bold">Expertise</h3>
      <p className="text-white text-lg">
        Bij X-TREMETUNINGS voeren wij altijd eerst een diagnose uit en
        overleggen dan samen met de klant wat de juiste oplossing is voordat wij
        de foutcode uitschakelen.
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="DTC REMOVAL" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default DTCRemoval;
